import React from 'react'

export default function Footer() {
  return (
  <footer class="py-5">
    <div class="container text-center text-white">
      <div class="fw-bold mb-2">Journey with Jones</div>
      <div class="small">© 2026 Journey with Jones</div>
            <div class="small">BABCP Member</div>
    </div>

     
  </footer>
  )
}
